const _ = require('../../../lodash');
const BaseEntry = require('./BaseEntry');
const getConstants = require('../../../utils/getConstants');
const constants = getConstants();
const DomainException = require('../../DomainException');
const { answerStates } = constants;

class PhotoEntry extends BaseEntry {
   constructor(aggregateRoot, componentData, items, entries, ruleEvaluator) {
      super(aggregateRoot, componentData, items, entries, ruleEvaluator);
   }

   updateAssetUris({ idAsset, localUri, remoteUri }) {
      const item = this.item;

      const reponses = [...item.response];

      const response = _.find(reponses, (x) => {
         return x.val.id == idAsset;
      });

      if (response) {
         response.val.localUri = localUri;

         if (remoteUri) {
            response.val.remoteUri = remoteUri;
         }

         const p = {
            idItem: this.idItem,
            response,
            noSubmissionItem: item.no,
            noSubmission: this._aggregateRoot.getSubmissionNo()
         };

         this.apply('PHOTO_FIELD_ASSET_URIS_UPDATED', p);

         item.response = reponses;
      }
   }

   update({ actionedOn, images, geoLat, geoLong, geoTimeStamp }) {
      const item = this.item;

      const newItemState = item.state | answerStates.ANSWERED;

      let responses = [];

      _.each(images, (so, index) => {
         let val = { localUri: so.localUri, remoteUri: so.remoteUri, mimeType: so.mimeType };

         // If there is an id provided this will be the id we use to
         // link to the mediaassets table once the image has been uploaded to the cloud
         // a job will then restamp the correct url from the mediaasset over the remote url and clear local
         if (so.id) {
            val.id = so.id;
         }

         const r = {
            no: index + 1,
            upd: so.upd ? so.upd : actionedOn,
            val
         };

         responses.push(r);
      });

      const p = {
         idItem: this.idItem,
         state: newItemState,
         actionedOn,
         responses,
         noSubmissionItem: item.no,
         noSubmission: this._aggregateRoot.getSubmissionNo(),
         geoLat,
         geoLong,
         geoTimeStamp
      };

      this.apply('PHOTO_FIELD_UPDATED', p);

      item.response = responses;
      item.state = newItemState;
      item.geoLat = geoLat;
      item.geoLong = geoLong;
      item.geoTimeStamp = geoTimeStamp;
   }

   tryParsePhoto(input) {
      let result = {};
      result.success = false;
      result.value = input;

      let parsedValue = null;

      try {
         const currentImage = input[0];

         const url = currentImage.val.localUri || currentImage.val.remoteUri;
         if (url == undefined) {
            throw new DomainException('Invalid image url');
         }

         parsedValue = input;
         result.success = true;
      } catch {
         result.success = false;
      }

      if (result.success) {
         result.value = parsedValue;
      }

      return result;
   }

   validateEntry() {
      const item = this.item;
      const { state } = item;
      let isInvalid = false;

      let isSkipped = (state & answerStates.SKIPPED) == answerStates.SKIPPED;

      if (
         (!_.isArray(item.response) ||
            (_.isArray(item.response) && item.response.length == 0) ||
            !this.tryParsePhoto(item.response).success) &&
         !isSkipped
      ) {
         isInvalid = true;
      }

      return isInvalid;
   }

   lock() {
      const item = this.item;
      const { state } = item;
      item.state = state | answerStates.LOCKED;
   }

   unlock() {
      const item = this.item;
      const { state } = item;
      item.state = state & ~answerStates.LOCKED;
   }

   validate() {
      const isValid = !this.validateEntry();
      return this.setCurrentValidity(isValid);
   }

   getFriendlyValue() {
      const item = this.item;
      // TODO
      // How do we summarise photos?
      console.log('PHOTO', item);
      return '';
   }
}

module.exports = PhotoEntry;
